var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransacciones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.386,
    height: 45,
    viewBox: "0 0 45.386 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transacciones",
    transform: "translate(0.011 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(-0.011 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(13.328 11.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path870",
    d: "M32,48V63.624",
    transform: "translate(-32 -44.874)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path874",
    d: "M224,96v10.942",
    transform: "translate(-204.573 -88.184)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path880",
    d: "M64,16h8.095",
    transform: "translate(-60.762 -16)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path882",
    d: "M64,240H76.951",
    transform: "translate(-60.762 -218.116)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path886",
    d: "M195.238,208A3.418,3.418,0,0,1,192,211.126",
    transform: "translate(-175.811 -189.242)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path886-3",
    d: "M3.238,3.126A3.424,3.424,0,0,0,0,0",
    transform: "translate(3.238 21.884) rotate(180)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path886-3-6",
    d: "M3.238,0A3.452,3.452,0,0,1,0,3.124",
    transform: "translate(3.238 3.124) rotate(180)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path933",
    d: "M152.086,23.823,144,16",
    transform: "translate(-132.667 -16)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path886-5",
    d: "M3.238,3.126A3.44,3.44,0,0,0,0,0",
    transform: "translate(14.57 7.816) rotate(180)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path950",
    d: "M144,20.69V16",
    transform: "translate(-132.667 -16)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path952",
    d: "M176,96h4.857",
    transform: "translate(-161.43 -88.184)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path827",
    d: "M64,208h4.857",
    transform: "translate(-60.762 -189.242)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path829",
    d: "M64,176h8.095",
    transform: "translate(-60.762 -160.368)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    d: "M64,144h4.857",
    transform: "translate(-60.762 -131.495)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2",
    "data-name": "Rect\\xE1ngulo 2",
    d: "M4.113,1.588A2.429,2.429,0,0,0,1.645,3.971V28.417A2.429,2.429,0,0,0,4.113,30.8h36.6a2.429,2.429,0,0,0,2.468-2.382V3.971a2.429,2.429,0,0,0-2.468-2.382H4.113M4.113,0h36.6a4.044,4.044,0,0,1,4.113,3.971V28.417a4.044,4.044,0,0,1-4.113,3.971H4.113A4.044,4.044,0,0,1,0,28.417V3.971A4.043,4.043,0,0,1,4.113,0Z",
    transform: "translate(0.327 6.007)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2_-_Contorno",
    "data-name": "Rect\\xE1ngulo 2 - Contorno",
    d: "M4.185-.15h36.6a4.267,4.267,0,0,1,4.335,4.185V28.481a4.267,4.267,0,0,1-4.335,4.185H4.185A4.267,4.267,0,0,1-.15,28.481V4.035A4.267,4.267,0,0,1,4.185-.15Zm36.6,32.388a3.83,3.83,0,0,0,3.891-3.756V4.035A3.83,3.83,0,0,0,40.786.279H4.185A3.83,3.83,0,0,0,.294,4.035V28.481a3.83,3.83,0,0,0,3.891,3.756Zm-36.6-30.8h36.6a2.647,2.647,0,0,1,2.69,2.6V28.481a2.647,2.647,0,0,1-2.69,2.6H4.185a2.647,2.647,0,0,1-2.69-2.6V4.035A2.647,2.647,0,0,1,4.185,1.438Zm36.6,29.211a2.21,2.21,0,0,0,2.246-2.168V4.035a2.21,2.21,0,0,0-2.246-2.168H4.185A2.21,2.21,0,0,0,1.939,4.035V28.481a2.21,2.21,0,0,0,2.246,2.168Z",
    transform: "translate(0.255 5.943)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_8",
    "data-name": "L\\xEDnea 8",
    d: "M14.039-.412H-1.177A.809.809,0,0,1-2-1.206.809.809,0,0,1-1.177-2H14.039a.809.809,0,0,1,.823.794A.809.809,0,0,1,14.039-.412Z",
    transform: "translate(16.515 42.552)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_8_-_Contorno",
    "data-name": "L\\xEDnea 8 - Contorno",
    d: "M14.111-.133H-1.105A1.028,1.028,0,0,1-2.15-1.141,1.028,1.028,0,0,1-1.105-2.15H14.111a1.028,1.028,0,0,1,1.045,1.009A1.028,1.028,0,0,1,14.111-.133ZM-1.105-1.721a.591.591,0,0,0-.6.58.591.591,0,0,0,.6.58H14.111a.591.591,0,0,0,.6-.58.591.591,0,0,0-.6-.58Z",
    transform: "translate(16.443 42.488)",
    fill: "#777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransacciones);
export default __webpack_public_path__ + "static/media/transacciones.508d9348afb0dd51334c53dac453b48d.svg";
export { ForwardRef as ReactComponent };